"use strict";

var _interopRequireDefault = require("/www/wwwroot/python/front/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _formatMixin = require("@/utils/formatMixin");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var _default = exports.default = {
  components: {
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  data: function data() {
    return {
      periodList: {
        count: 0
      },
      //划扣分期
      listLoading: false,
      listQuery: {
        page: 1,
        page_size: 10
        // pageSizes:[10]
      },
      pk: 0
    };
  },
  created: function created() {
    this.pk = this.$route.query.pk;
    this.getPeriodList();
  },
  methods: {
    cancelRendlist: function cancelRendlist() {
      var _this = this;
      var selection = this.multipleSelection;
      if (selection.length <= 0) {
        this.$message.error('请至少勾选一个扣款周期');
        return;
      }
      var ids = '';
      var _iterator = _createForOfIteratorHelper(selection),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          console.log(item);
          if (item.is_cancel == false && item.status == false) {
            ids = ids + ',' + item.id;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (ids == '') {
        this.$message.error('无需取消');
        return;
      }
      this.listLoading = true;
      (0, _request.default)({
        url: "/system/order/cancel_hk_list/",
        method: 'put',
        data: {
          order_id: this.pk,
          ids: ids
        }
      }).then(function (response) {
        if (response.data) {
          _this.getPeriodList();
          // this.orderList = response.data
          // this.orderList = this.orderList.reverse()
        }
        _this.listLoading = false;
      });
      // console.log(ids)
    },
    // 获取划扣分期
    getPeriodList: function getPeriodList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/OrderHk/",
        method: 'get',
        params: Object.assign({
          shop: this.$user.data.shop
        }, {
          order: this.pk
        }, this.listQuery)
      }).then(function (response) {
        if (response.data) {
          _this2.periodList = response.data;
          // this.periodList = this.periodList.reverse()
        }
        _this2.listLoading = false;
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
};